import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { pageMeta } from '../config/seo';
import SeoHead from '../components/SeoHead';
import './NotFound.css';

export default function NotFound() {
  const { siteName } = useSite();
  const meta = pageMeta.notFound;

  return (
    <main className="page not-found">
      <SeoHead
        title={meta.title}
        description={meta.description}
        robots={meta.robots}
      />
      <div className="not-found__inner">
        <p className="not-found__code" aria-hidden>
          404
        </p>
        <h1 className="not-found__title">Sayfa bulunamadı</h1>
        <p className="not-found__text">
          Aradığınız adres yanlış yazılmış veya kaldırılmış olabilir.
        </p>
        <Link to="/" className="not-found__link">
          {siteName} anasayfasına dön
        </Link>
      </div>
    </main>
  );
}
